import { FC } from "react";

type Props = {
	tabs: string[];
	setTab: any;
	currentTab: string;
};

const Tabs: FC<Props> = ({ tabs, currentTab, setTab }) => {
	return (
		<div className='flex flex-wrap justify-center gap-[22px] max-desktop:gap-[13px] max-tablet:gap-[6px] px-[229px] max-desktop:px-[80px] max-tablet:px-[30px]'>
			{tabs.map((el, index) => (
				<a href={"#faq"} key={index} style={{ all: "unset" }}>
					<div
						onClick={() => setTab(el)}
						className={`w-[229px] h-[100px] max-desktop:w-[142px] max-desktop:h-[62px] ${
							currentTab === el ? "bg-white text-main" : "text-white"
						} flex items-center justify-center rounded-[15px] border-[2px] px-[21px] max-desktop:px-[13px] transition-all duration-300 ease-in-out cursor-pointer  hover:text-main hover:bg-white`}>
						<p className='text-[27px] max-desktop:text-[16px]  text-center font-bold leading-7 max-desktop:leading-4 underline-none'>
							{el}
						</p>
					</div>
				</a>
			))}
		</div>
	);
};

export default Tabs;
